/** Selection-mode key used while picking the three IFC alignment points in the scene. */
export const CONFIGURE_TRANSFORMATION_SELECTION_KEY = 'ifc-configure-transformation'

/** Common right-angle rotations offered as quick "snap" suggestions for the alignment angle. */
export const angles = [0, 90, 180, 270, 360]

/** Max distance (in degrees) for a typed angle to be considered near a snap angle. */
export const ANGLE_SNAP_OFFSET = 5

/**
 * Title + description shown as the drawer header for each toolbar-activated IFC mode (keyed by
 * `ifcMode`). Rendered by `IFCModeDrawer`, mirroring the guided-workflow step header.
 */
export const IFC_MODE_HEADERS: Record<string, { title: string; description: string }> = {
  add: {
    title: 'IFC-Datei hinzufügen',
    description: 'Laden Sie eine IFC-Datei hoch und konvertieren Sie sie.',
  },
  settings: {
    title: 'Datei',
    description: 'Verwalten Sie die aktive IFC-Datei.',
  },
  alignment: {
    title: 'Ausrichtung',
    description: 'Positionieren Sie das Modell am Koordinatensystem.',
  },
  filter: {
    title: 'Filtern',
    description: 'Wählen Sie die zu importierenden Elemente.',
  },
  storey: {
    title: 'Stockwerkszuweisung',
    description: 'Weisen Sie Elemente den Stockwerken zu.',
  },
  type: {
    title: 'Typenzuweisungen',
    description: 'Weisen Sie Elemente einem Typ zu.',
  },
  building: {
    title: 'Gebäudedimensionen',
    description: 'Legen Sie die Gebäudedimensionen fest.',
  },
  'draw-roofs': {
    title: 'Dachflächen (3D)',
    description: 'Zeichnen Sie Dachflächen ein.',
  },
  'draw-walls': {
    title: 'Wände (2D)',
    description: 'Zeichnen Sie Wände ein.',
  },
  'draw-openings': {
    title: 'Öffnungen (Draufsicht)',
    description: 'Zeichnen und bearbeiten Sie Öffnungen direkt auf der Wand.',
  },
  'auto-connect': {
    title: 'Wände automatisch zuschneiden',
    description: 'Verbinden Sie nicht verbundene Wände eines Stockwerks im Grundriss.',
  },
}
